<div class="container-fluid">
    <div class="row pt-4">
        <div class="col-md-12 text-center mb-2">
            <small>Copyright ©2024 <a href="https://digitalunion.softwaveinnovation.com"><b>Digital Union</b></a>. Developed by <a href="https://softwaveinnovation.com/"><b>Softwave Innovation</b></a></small>
        </div>
        <div class="col-md-12 text-center mb-3">
            <a href="https://www.facebook.com/softwaveinnovation/" target="_blank" class="btn btn-sm bg-light text-dark shadow-sm rounded-circle text-light m-2"><i class="fab fa-facebook"></i></a>
            <a href="#" target="_blank" class="btn btn-sm bg-light text-dark shadow-sm rounded-circle text-light m-2"><i class="fab fa-twitter"></i></a>
            <a href="mailto:softwaveinnovation24@gmail.com" target="_blank" class="btn btn-sm bg-light text-dark shadow-sm rounded-circle text-light m-2"><i
            class="fas fa-envelope"></i></a>
            <a href="#" target="_blank" class="btn btn-sm bg-light text-dark shadow-sm rounded-circle text-light m-2"><i
            class="fab fa-linkedin-in"></i></a>
        </div>

        <div>

        </div>






    </div>

</div>